import type { AppBadgeType } from '../apps-badges';
import type { AppsPlans } from './apps-plans';

export type queryAppsPlans = (payload: {
  appIds: string[];
}) => Promise<AppsPlans>;

export enum DurationUnit {
  UNKNOWN_UNIT = 'UNKNOWN_UNIT',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum CycleType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
}

export type IAppPlans = {
  taxSettings: TaxDetails;
  currency: CurrencySettings;
  appId: string;
  plans: IAppPlan[];
  saleBadge?: AppBadgeType;
};

export type IAppPlan = {
  meterdBilling?: MeterdBilling;
  yearlyPrice?: string;
  monthlyPrice?: string;
  oneTimePrice?: string;
  vendorId: string;
  discount?: Discount;
};

export type CurrencySettings = {
  code: string;
  symbol: string;
};

export enum EDisplayTaxType {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  VAT = 'VAT',
  GST = 'GST',
}

export type TaxDetails = {
  showPriceWithTax: boolean;
  displayTaxType: EDisplayTaxType;
};

export type MeterdBilling = {
  outline?: string;
  baseFee: string;
};

export enum ESaleType {
  UNKNOWN_SALE_TYPE = 'UNKNOWN_SALE_TYPE',
  WIX_SALE = 'WIX_SALE',
  DEVELOPER_SALE = 'DEVELOPER_SALE',
}

export enum DiscountType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  DISCOUNT_TYPE_UNSPECIFIED = 'DISCOUNT_TYPE_UNSPECIFIED',
}

export type Discount = {
  type: DiscountType;
  amount: string;
  saleType: ESaleType;
};

function isWixSale(saleId: string): boolean {
  const validWixSalesIds = [
    '81a7f745-e49a-4239-9f12-761b17ceb25c',
    '37711c43-832c-4acb-ae54-12965ab6d70b',
    'b1d2b42f-f4d3-405c-9d99-236829a31a1b',
    '48d01ac1-1120-4691-ba6a-722ed6c51efc',
  ];
  return validWixSalesIds.includes(saleId);
}

function isDevSale(saleId: string): boolean {
  return saleId === 'Harta Barta';
}
// TODO: add devSale Id when ready

export function getSaleType(saleId: string): ESaleType {
  return isWixSale(saleId)
    ? ESaleType.WIX_SALE
    : isDevSale(saleId)
    ? ESaleType.DEVELOPER_SALE
    : ESaleType.UNKNOWN_SALE_TYPE;
}
